module.exports = __webpack_public_path__ + "static/media/faico-360-flecha.4897786e.png";